/**
 * The highlighter, CODE-SPLIT: the code panel imports this module only when a code panel renders, so a room with no
 * code never downloads highlight.js. Same library + theme as the workspace code viewer.
 */
import hljs from 'highlight.js/lib/common';
import 'highlight.js/styles/github.css';

const MAX_HIGHLIGHT_CHARS = 200 * 1024;   // past this, plain text — colouring a huge file would freeze the tab

/** code + grammar → HTML ('' grammar or an unknown one → auto-detect; too big or a failure → null = show plain). */
export function highlightCode(code = '', grammar = '') {
  const s = String(code || '');
  if (!s || s.length > MAX_HIGHLIGHT_CHARS) return null;
  try {
    if (grammar === 'plaintext') return null;
    if (grammar && hljs.getLanguage(grammar)) return hljs.highlight(s, { language: grammar, ignoreIllegals: true }).value;
    return hljs.highlightAuto(s).value;
  } catch {
    return null;
  }
}
